import loadable from '@loadable/component';

/**
 * Code-split wrapper for SearchByImageBottomSheet — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
export const SearchByImageBottomSheet = loadable(
    /* #__LOADABLE__ */
    () => import('./SearchByImageBottomSheet'),
    {
        resolveComponent: (components) => components.SearchByImageBottomSheet,
        ssr: false,
    }
);
